module.exports = __webpack_public_path__ + "img/luckynumber.a05f8de8.png";